<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
       <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-input-number
                class="qweelement"
                v-model="data[name]"
                :disabled="disabled"
                :min="min"
                :max="max"
                step-strictly
                :controls="selfSetting.IsControls"
                controls-position="right"
                :precision = "selfSetting.Scale"
                :step = "Step"
                >
            </el-input-number>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import baseNumericField from "./BaseNumericField"

    export default {
        name:"NumericField",
        mixins:[baseNumericField]
    }
</script>